// extracted by mini-css-extract-plugin
export default {"banner":"sI0Fx4oxOasUZEhcNrq_","container":"uOxKwi5V5w291DO9djrj","image":"HTAARKWrVY0Lx9b3NWfy","logo":"qlNggp3fMJzGXlgnIVB2"};